<template>
  <div class="Sobre">
    <div class="libe_home_nav" v-if="scroll >= 88">
      <headNav :activeNav="'sobre'"></headNav>
    </div>
    <div class="libe_home_wrap">
      <div class="libe_homenav" v-if="scroll < 88 ">
        <homeNav :activeNav="'sobre'"></homeNav>
      </div>
      <div class="libe_home_banner">
        <div class="libe_home_banner_img">
          <img src="../assets/img/rapiyuda_home_banner_two.png" alt="">
        </div>
      </div>
      <div style="margin:0 auto; ">
        <div class="bigContent">
          <div class="content clearfix">
            <div class="left">
              <div class="rapiyuda_about_title">Perfil de la empresa</div>
              <p><span><u>Arrecredi</u></span>
                 es una plataforma que ofrece préstamos en línea rápidos, accesibles y seguros. Regístrate en segundos, aplica para un préstamo y recibe tu efectivo en minutos.Vemos el mundo diferente. Estamos motivados por una creencia fundamental en las personas, y trabajamos juntos para demostrar su potencial. Asumimos riesgos que otros no tomarían para poner más poder en las manos de nuestros clientes.
              </p>
            </div>
            <div class="right">
              <div class="about_img_view">
                <img src="@/assets/img/rapi_about_one.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="rapihomethr_wrap">
        <div class="rapihomethr_bgview">
          <div class="rapihomethr_bgtop"></div>
          <div class="rapihomethr_bgdown"></div>
        </div>
        <div class="rapihomethr_cview">
          <div class="rapihomethr_cont">
            <div class="rapihomethr_ccview">
              <div class="rapihomethr_ccvtop">
                <div class="rapihomethr_ccvttitle">Contáctanos</div>
                <div class="rapihomethr_ccvtdesc"> Si necesitas ayuda, envíanos un correo o llamar a nuestro teléfono de atención al cliente.</div>
              </div>
              <div class="rapihomethr_ccvdown">
                <div class="rapihomethr_ccvd_left">
                  <img src="@/assets/img/rapi_homethr.png" alt="" />
                </div>
                <div class="rapihomethr_ccvd_right">
                  <div class="rapihomethr_ccvd_ritems">
                    <div class="rapihomethr_ccvd_ritem_left">
                      <img src="@/assets/img/rapi_icon_mobile.png" alt="">
                    </div>
                    <div class="rapihomethr_ccvd_ritem_right">
                      <div class="rapihomethr_ccvd_ritem_rview">
                        <div class="rapihomethrccvdritemrv_title">Atención al Cliente：</div>
                        <div class="rapihomethrccvdritemrv_desc">5594484815</div>
                      </div>
                    </div>
                  </div>

                  <div class="rapihomethr_ccvd_ritems">
                    <div class="rapihomethr_ccvd_ritem_left">
                      <img src="@/assets/img/rapi_icon_email.png" alt="">
                    </div>
                    <div class="rapihomethr_ccvd_ritem_right">
                      <div class="rapihomethr_ccvd_ritem_rview">
                        <div class="rapihomethrccvdritemrv_title">Email：</div>
                        <div class="rapihomethrccvdritemrv_desc"></div>
                      </div>
                    </div>
                  </div>

                  <div class="rapihomethr_ccvd_ritems">
                    <div class="rapihomethr_ccvd_ritem_left">
                      <img src="@/assets/img/rapi_icon_client.png" alt="">
                    </div>
                    <div class="rapihomethr_ccvd_ritem_right">
                      <div class="rapihomethr_ccvd_ritem_rview">
                        <div class="rapihomethrccvdritemrv_title">Tiempo laboral：</div>
                        <div class="rapihomethrccvdritemrv_des">De Lunes a Domingo：9am-6pm</div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <footPage></footPage>
  </div>
</template>

<script>
import headNav from "@/components/headNav.vue";
import homeNav from "@/components/homeNav.vue";
import footPage from "@/components/foot.vue";
import "../components/scss/sobre.scss";

export default {
    name: "Sobre",
    components: { headNav, homeNav, footPage },
    data() {
      return {
        scroll: 0,
      }
    },
    mounted(){
      window.addEventListener('scroll',this.handleScroll)
    },
    methods: {
      handleScroll(){
        //或者使用document.querySelector('.class或者#id').scrollTop
        this.scroll = document.documentElement.scrollTop||document.body.scrollTop
      },
    },
    //销毁,否则跳到别的路由还是会出现
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>

<style>

  .eshoy_abtitle_icon img{
    display: block;
    width: 100%;
  }

  .fotop_cont_dit_img img{
    display: block;
    width: 100%;
  }

  .about_img_view{
    width: 466px;
    height: 500px;
    position: relative;
  }
  .bigContent img {
    position: absolute;
    width: 466px;
    height: 500px;
    left: 0;
    top: -40px;
  }

  .content {
    margin-top: 26px;
  }

  .rapiyuda_about_title {
    border-bottom: 5px solid;
    border-image: linear-gradient(305deg, rgba(77, 95, 242, 1), rgba(36, 34, 202, 1)) 5 5;
    width: 270px;
    font-size: 30px;
    color: #333;
    font-weight: 500;
    line-height: 60px;
    margin-bottom: 30px;
    position: relative;
  }

  .content .right {
    float: right;
    width: 440px;
    height: 420px;
  }

  /* 移动端适配 */
  @media (max-width: 768px) {
    .bigContent {
      width: 100%;
      box-sizing: border-box;
      padding: 0 16px;
    }
    .content {
      display: flex;
      flex-direction: column;
    }
    .content .left {
      width: 100%;
      margin-bottom: 24px;
    }
    .content .right {
      float: none;
      width: 100%;
      height: auto;
      order: -1;
    }
    .about_img_view {
      width: 100%;
      height: auto;
      max-width: 300px;
      margin: 0 auto;
    }
    .bigContent img {
      position: relative;
      width: 100%;
      height: auto;
      left: 0;
      top: 0;
    }
    .rapiyuda_about_title {
      width: 100%;
      font-size: 24px;
      line-height: 36px;
      margin-bottom: 20px;
    }
    .rapihomethr_wrap {
      padding: 0 16px;
    }
    .rapihomethr_ccvd_ritems {
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 20px;
    }
    .rapihomethr_ccvd_ritem_left {
      margin-bottom: 8px;
    }
  }
</style>
